import { NotificationService } from './../../../../../core/src/lib/notifications/notifications.service';
import { Component, OnInit } from '@angular/core';
import { Observable } from 'rxjs';
import { GatewayFacade } from 'libs/gateway/src/lib/states/+gateway/gateway.facades';
import { GroupDto } from '@cradua/data';
import { ROUTE_ANIMATIONS_ELEMENTS } from '@cradua/core';

@Component({
  selector: 'cradua-group-container',
  templateUrl: './group-container.component.html',
  styleUrls: ['./group-container.component.scss']
})
export class GroupContainerComponent implements OnInit {
  routeAnimationsElements = ROUTE_ANIMATIONS_ELEMENTS;
  groups$: Observable<GroupDto[]>;
  loading: boolean;
  isLoadingGroup$: Observable<boolean>;
  constructor(
    private gatwayFacade: GatewayFacade,
  ) {}

  ngOnInit() {
    this.isLoadingGroup$ = this.gatwayFacade.isLoadingGateway("Group");
    this.groups$ = this.gatwayFacade.loadGateway("Group");
  }

/**
 this method dispatches array of ids to the effects,
 which handle the sending of data asynchronously
  */

  onDeleteGroup(deletedValue: any) {
    this.gatwayFacade.remove("Group", deletedValue);
  }


// this method control both the create and update

  onSubmitGroup(formValue: any) {
    // event.preventDefault();
    const pullData = formValue.Groups;

// declare two empty arrays to hold update and create data
  const allUpdates = [] ;
  const addAllGroup = [];


// loop through the form data to check for update and create
  for(let i = 0; i < pullData.length; i++) {
    if(pullData[i].id !== null) {
      allUpdates.push(pullData[i]);
    } else {
      delete pullData[i].id;
      addAllGroup.push(pullData[i]);
    }
  }

// check if the addAllGroup array is not empty, then dispatch the data to the store
   if(addAllGroup.length > 0) {
    this.gatwayFacade.add('Group', addAllGroup);
   }

   if(allUpdates.length > 0) {
     // dispatch update data to the store
    this.gatwayFacade.update('Group', allUpdates, ['id']);
  }

   }


}


